import { render, staticRenderFns } from "./IsoCodeToLocationCodeDependenciesTable.vue?vue&type=template&id=71e02374&"
import script from "./IsoCodeToLocationCodeDependenciesTable.vue?vue&type=script&lang=js&"
export * from "./IsoCodeToLocationCodeDependenciesTable.vue?vue&type=script&lang=js&"
import style0 from "./IsoCodeToLocationCodeDependenciesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports